import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { COMPONENT_GLOBAL_CONFIG } from "../constants";
export const STOCK_THEMES = {
    'v3': {
        icon_themes: {
            'outlined': {
                icons: [{
                    icon: 'help',
                    jsx: <HelpOutlineOutlinedIcon />
                }, {
                    icon: 'filter-list',
                    jsx: <FilterListOutlinedIcon />
                }, {
                    icon: 'notifications',
                    jsx: <NotificationsOutlinedIcon />
                }],
                // default icon to use if the slug has no match
                missingo: <HelpOutlineOutlinedIcon />
            }
        },
        palette: {
            primary: {
                main: '#1976D2',
                light: '#2284e5',
                dark: '#176abd'
            },
            secondary: {
                main: '#05182a',
                contrastText: '#ffffff',
                light: '#05182a',
                dark: '#05182a',
            },
            warning: {
                main: '#FFDA24',
            },
            success: {
                main: '#a6d8a7',
                light: '#afdcb0',
                dark: '#8bcc8d'
            },
            divider: '#c2c2c2',
            error: {
                main: '#ea8684',
                light: '#ec9290',
                dark: '#e56765',
            },
        },
        typography: {
            fontFamily: "'Inter', sans-serif",
            fontWeightMedium: 600,
            fontWeightRegular: 500,
            fontWeightLight: 400,
            fontWeightBold: 700,
        },
        components: {
            MuiChip: {
                styleOverrides: {
                    root: {
                        border: `1px solid #c2c2c2`,
                        backgroundColor: 'white',
                        borderRadius: '180px',
                    }
                }
            },
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        overflow: 'visible'
                    }
                }
            },
            MuiStack: {
                styleOverrides: {
                    root: {
                        position: 'relative'
                    }
                }
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        width: '100%'
                    },
                }
            },
            MuiTooltip: {
                defaultProps: {
                    arrow: true,
                    enterNextDelay: COMPONENT_GLOBAL_CONFIG.TOOLTIP.ENTER_NEXT_DELAY,
                    enterDelay: COMPONENT_GLOBAL_CONFIG.TOOLTIP.ENTER_DELAY,
                },
            },
            MuiTabs: {
                styleOvverides: {
                    root: {
                        height: '33px'
                    }
                }
            },
            MuiAppBar: {
                defaultProps: { color: 'secondary' }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        height: "38px",
                        textTransform: "capitalize",
                    }
                }
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        padding: "7.5px",
                        ":hover": {
                            color: '#1976D2',
                        },
                    },
                },
            },
            MuiTable: {
                styleOverrides: {
                    root: {
                        ".MuiTableCell-root": { height: "48px" }
                    },
                },
            }
        },
        custom: {
            white70: 'rgba(255, 255, 255, 0.7)',
            white: '#ffffff',
            tableAlternateBG: '#f5f5f5',
        
            darkestAccent: '#05182a',
            mainSecondaryColor: '#0d3b69',
            mainButtonHighlight: '#1976D2',
    
            mainIconColor: '#828282',
            iconScaleFactor: 1.08,
        
            mainHeaderColor: '#434343',
            text: "rgba(0, 0, 0, 0.87)",
                 
            hoverOptionColor: '#deebff',
            menuBoxShadow: 'rgb(0 0 0 / 10%) 1px 0px 6px 1px, rgb(0 0 0 / 10%) 0px 4px 11px',
            menuZIndex: 54,
            menuInsideModalZIndex: 1310,
                
            borderGrey: '#c2c2c2',
            disabledColor: '#e6e6e6',
            clickAwayZIndex: 51,
            menuClickAwayZIndex: 53,
            dialogZIndex: 52,
            pendingChangeIndicatorColor: '#FFF9C4',
            mainBackgroundColor: '#f4f4f4',
        
            validInsightGreen: '#A5D6A7',
            invalidInsightRed: '#EF918F',
        
            grayLabelText: 'rgba(0, 0, 0, 0.6)',
            primary50: 'rgba(25, 118, 210, 0.5)',
            primary10: 'rgba(25, 118, 210, 0.1)',
            gray40: 'rgba(0, 0, 0, 0.4)',
            gray60: 'rgba(0, 0, 0, 0.6)',
            gray3: 'rgba(0, 0, 0, 0.03)',
            gray6: 'rgba(0, 0, 0, 0.06)',
            gray26: 'rgba(0, 0, 0, 0.26)',
        
            fontFamily: "'Inter', sans-serif",
        
            timingFunction1: 'cubic-bezier(0.4, 0, 0.2, 1)',
        
            homeCardBoldGray: '#757575',
            entryCardBoldGray: '#757575',
            recordingIndicatorColor: '#e55353',
        
            scoringToolbarBg: '#fafafa',
        
            textSelectionColor: 'rgb(151, 207, 224)',
        
            deletedMessagePrimaryColor: 'rgba(25, 118, 210, 0.2)',
            deletedMessageSecondaryColor: 'rgba(230, 230, 230, 0.5)',
          },
    }
}
